import { lazy } from 'react';
import { authRoles } from 'src/app/auth';
const PrintDocuments = lazy(() => import('./PrintDocuments'));

const PrintDocumentsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/print-documents',
      element: <PrintDocuments />,
    },
  ],
};

export default PrintDocumentsConfig;
